export const server = (process.env.NODE_ENV === 'production') ? 'https://squash.roslaw.pl/api' : 'http://localhost:9097/api';
